import { render } from "./footerDesktop.vue?vue&type=template&id=bf9ab6d6"
const script = {}

import "../assets/css/header.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__